module.exports = __webpack_public_path__ + "assets/6b48f5e5248f3a79d96df615883196e2.png";